const updates = [
  { date: '2026-07-31', title: '《流浪地球3》4K蓝光版已上线', tag: '上新' },
  { date: '2026-07-30', title: '暑期档专题合集更新，新增32部热门电影', tag: '专题' },
  { date: '2026-07-28', title: 'CDN节点扩容完成，播放速度提升40%', tag: '优化' },
  { date: '2026-07-25', title: '《封神第二部》超清版本全网首发', tag: '首发' },
  { date: '2026-07-22', title: '华语电影专区新增经典港片修复版50部', tag: '上新' },
  { date: '2026-07-20', title: '移动端观影体验全面升级，适配折叠屏', tag: '优化' },
  { date: '2026-07-18', title: '豆瓣高分TOP100排行榜本周更新', tag: '榜单' },
  { date: '2026-07-15', title: '悬疑烧脑专题上线，收录143部高能佳作', tag: '专题' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">最新动态</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">实时了解桃子影院的片库更新与平台动态</p>

        <div className="relative pl-6 md:pl-8">
          <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-background-300/50"></div>

          <div className="space-y-5 md:space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative pl-5 md:pl-7">
                <div className="absolute left-[-22px] md:left-[-27px] top-1.5 w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>

                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-[11px] md:text-xs text-foreground-400 font-mono">{item.date}</span>
                  <span
                    className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.tag === '上新' || item.tag === '首发'
                        ? 'bg-accent-500/15 text-accent-400'
                        : item.tag === '专题' || item.tag === '榜单'
                          ? 'bg-primary-500/15 text-primary-400'
                          : 'bg-secondary-500/15 text-secondary-400'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-100 font-medium">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}